import { Component, computed, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGear, faLanguage } from '@fortawesome/pro-regular-svg-icons';

import { UiAdminModule } from '@eiq/ui';

import { AddLanguageDialogComponent } from './add-language-dialog/add-language-dialog.component';
import { LanguageSettingsComponent } from './language-settings/language-settings.component';
import { TranslationsEditorComponent } from './translations-editor/translations-editor.component';
import { TranslationTabs } from '../../models/translations/translation-tabs.enum';
import { EditorTranslationsService } from '../../services/editor-translations.service';

@Component({
  standalone: true,
  selector: 'empathy-translations',
  templateUrl: 'translations.component.html',
  styleUrls: ['translations.component.scss'],
  imports: [FontAwesomeModule, LanguageSettingsComponent, MatTabsModule, TranslationsEditorComponent, UiAdminModule]
})
export class TranslationsComponent {
  translationsService = inject(EditorTranslationsService);

  languages$ = computed(() => this.translationsService.languages$().filter((l) => !this.translationsService.translations$().some((t) => t.code === l.code)));

  activeTabIndex$ = this.translationsService.activeTabIndex$;

  faGear = faGear;
  faLanguage = faLanguage;

  translationTabs = TranslationTabs;

  private dialog = inject(MatDialog);

  onAddLanguage(): void {
    this.dialog.open(AddLanguageDialogComponent, {
      data: { languages: this.languages$() }
    });
  }
}
